import { Pill } from '@iwoca/orion';
import styles from './ProbabilityPill.module.css';

const PROBABILITY_PILLS = {
  low_probability_of_offer: {
    label: 'Low chance of approval',
    variant: 'red',
  },
  medium_probability_of_offer: {
    label: 'Medium chance of approval',
    variant: 'yellow',
  },
  high_probability_of_offer: {
    label: 'High chance of approval',
    variant: 'green',
  },
} as const;

type TProps = {
  probability:
    | 'low_probability_of_offer'
    | 'medium_probability_of_offer'
    | 'high_probability_of_offer';
};
export const ProbabilityPill = ({ probability }: TProps) => {
  const pill = PROBABILITY_PILLS[probability];
  if (!pill) {
    return null;
  }

  return (
    <Pill className={styles.pill} variant={pill.variant}>
      {pill.label}
    </Pill>
  );
};
